import { InputPlugin } from "./plugins/InputPlugin";
import { TrackNodeEvent } from "./TrackNode";
import { LocalMediaEvent } from "./LocalMediaManager";
import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
import { PlayerMediaSource } from "../PlayerMediaSource";
import { newLocalVideoDevice } from "./SpecificLocalDevices";
import { TrackPipeline } from "./TrackPipeline";
import { LocalVideoQualityManager } from "./LocalVideoQualityManager";
export class VideoManager extends GatherEventEmitter {
    device = newLocalVideoDevice();
    mediaSource = new PlayerMediaSource({ playerId: "SELF_VIDEO", isSelfView: true });
    pipeline = new TrackPipeline(new InputPlugin("video", this.device));
    qualityManager;
    production;
    constructor(pm) {
        super();
        this.qualityManager = new LocalVideoQualityManager(pm, this.device);
    }
    start(plugins, production) {
        this.production = production;
        production.unmute();
        const cleanupCallbacks = [
            this.pipeline.input.addEventListener(TrackNodeEvent.TrackChanged, (track) => {
                if (track) {
                    this.publishEvent(LocalMediaEvent.MuteChanged, false);
                }
                else {
                    this.publishEvent(LocalMediaEvent.MuteChanged, true);
                }
            }, { leading: true }),
            this.pipeline.build([...plugins, production]),
            this.pipeline.output?.addEventListener(TrackNodeEvent.TrackChanged, (track) => {
                if (track) {
                    this.mediaSource.addTrack(track.get());
                }
                else {
                    this.mediaSource.clear();
                }
            }, { leading: true }),
            this.device.start(),
        ];
        return () => cleanupCallbacks.forEach((c) => c?.());
    }
    async changeSettings(settings, reload = true) {
        await this.device.changeSettings(settings, reload);
    }
    async mute() {
        await this.device.mute();
    }
    async unmute() {
        await this.device.unmute();
    }
    resetPipeline() {
        const track = this.device.videoTrack;
        if (track) {
            this.pipeline.input.plugin.trackChanged(undefined);
            this.pipeline.input.plugin.trackChanged(track);
        }
    }
    debugInfo() {
        return this.pipeline.debugInfo();
    }
}
//# sourceMappingURL=VideoManager.js.map